import { render, staticRenderFns } from "./RandomProducts.vue?vue&type=template&id=74198b39&scoped=true&"
import script from "./RandomProducts.vue?vue&type=script&lang=js&"
export * from "./RandomProducts.vue?vue&type=script&lang=js&"
import style0 from "./RandomProducts.vue?vue&type=style&index=0&id=74198b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74198b39",
  null
  
)

export default component.exports